/* Products catalogue — mobile atmosphere colour.
   Sets --page-halo on <body> to the currently-centred product's finish colour so the
   fixed .field atmosphere (see css-products-p2.css) crossfades from product to product
   as you scroll. Pure progressive enhancement: if this never runs the atmosphere just
   shows the default. Harmless on desktop (only the mobile CSS consumes --page-halo). */
(function () {
  var items = [].slice.call(document.querySelectorAll('.cat-item[data-halo]'));
  if (!items.length) return;
  var body = document.body;
  function set(h) { if (h) body.style.setProperty('--page-halo', h); }
  set(items[0].getAttribute('data-halo'));
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting && e.intersectionRatio >= 0.6) {
        set(e.target.getAttribute('data-halo'));
      }
    });
  }, { threshold: [0.6] });
  items.forEach(function (i) { io.observe(i); });
})();
